/**
 * Date helper utilities to replace dayjs
 */

export const formatDate = (date: string | Date, format: string = 'MMM D, YYYY'): string => {
  const d = new Date(date);
  const options: Intl.DateTimeFormatOptions = {};

  switch (format) {
    case 'MMM D, YYYY':
      options.month = 'short';
      options.day = 'numeric';
      options.year = 'numeric';
      break;
    case 'MMMM D, YYYY h:mm A':
      options.month = 'long';
      options.day = 'numeric';
      options.year = 'numeric';
      options.hour = 'numeric';
      options.minute = 'numeric';
      options.hour12 = true;
      break;
    case 'YYYY-MM-DD':
      return d.toISOString().split('T')[0];
    default:
      return d.toLocaleDateString();
  }

  return d.toLocaleDateString('en-US', options);
};

export const subtractDays = (days: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString();
};

export const subtractHours = (hours: number): string => {
  const d = new Date();
  d.setHours(d.getHours() - hours);
  return d.toISOString();
};

export const subtractMonths = (months: number): string => {
  const d = new Date();
  d.setMonth(d.getMonth() - months);
  return d.toISOString();
};

export const subtractWeeks = (weeks: number): string => {
  const d = new Date();
  d.setDate(d.getDate() - weeks * 7);
  return d.toISOString();
};

export const fromNow = (date: string | Date): string => {
  const d = new Date(date);
  const now = new Date();
  const diff = now.getTime() - d.getTime();

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);

  if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
  if (weeks > 0) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  return 'just now';
};

export const getCurrentDate = (): string => {
  return new Date().toISOString();
};

export const calculateAge = (birthDate: string | Date): number => {
  const birth = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};
